import {AccessRole} from "enums/accessRole";
import {ACCESS_ROLE_LABEL} from "constants/accessRoleLabel";

const ACCESS_ROLES = Object.entries(AccessRole)
  .filter((pred) => pred[1] !== AccessRole.Owner)
  .map(entry => ({name: ACCESS_ROLE_LABEL[entry[0] as AccessRole], value: entry[1]}))

export default ACCESS_ROLES;